import React from "react"
export const InvisibilityIcon = ({ fill, className }) => 
<svg
  xmlns="http://www.w3.org/2000/svg"
  className={className}
  fill={fill}
  stroke='currentColor'
  strokeWidth='0'
  strokeLinecap='round'
  strokeLinejoin='round'
  width="24" height="24"
  x="0px" y="0px"
  viewBox="52.785 61.569 60.45 41.3">
  <g transform="matrix(1, 0, 0, 1, 51.009801, 50.16887)">
    <g>
      <path d="M32,52.7C12.2,52.7,2.4,33.8,2,33c-0.3-0.6-0.3-1.4,0-2c0.4-0.8,10.2-19.6,30-19.6c19.8,0,29.6,18.8,30,19.6 c0.3,0.6,0.3,1.4,0,2C61.6,33.8,51.8,52.7,32,52.7z M6.6,32C8.8,35.7,17.4,48.2,32,48.2c14.6,0,23.2-12.5,25.4-16.2 C55.2,28.3,46.6,15.8,32,15.8C17.4,15.8,8.8,28.3,6.6,32z"/>
    </g>
    <g>
      <path d="M32,40.5c-4.7,0-8.5-3.8-8.5-8.5c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5C40.5,36.7,36.7,40.5,32,40.5z M32,28 c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C36,29.8,34.2,28,32,28z"/>
    </g>
  </g>
  <rect
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    x="45.974" y="77.071" width="70.462" height="4.474"
    rx="2.237" ry="2.237" transform="matrix(0.866025, -0.5, 0.5, 0.866025, -27.145741, 54.430711)"/>

</svg>
